module.exports = __webpack_public_path__ + "static/media/ledger.b6ae0472.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/ledger.svg
// module id = 1846
// module chunks = 0